import {
  NotificationAudienceType,
  NotificationCampaignType,
  NotificationChannelType,
  NotificationRecipientType,
  NotificationRecurrenceFrequency,
  NotificationScheduleType,
} from "../../../redux/type";

export type {
  NotificationAudienceType,
  NotificationCampaignType,
  NotificationChannelType,
  NotificationRecipientType,
  NotificationRecurrenceFrequency,
  NotificationScheduleType,
} from "../../../redux/type";

export interface NotificationStat {
  key: "email" | "push" | "in_app";
  label: string;
  value: number;
}

export interface ChannelSelectionForm {
  channel: NotificationChannelType;
  recipient_type: NotificationRecipientType;
}

// Rich-text formatting (and the unlimited length that comes with it) only
// makes sense for email — push/in-app notifications render as plain text,
// so the body field switches to a plain, length-capped textarea unless
// Email is the one and only selected channel.
export function isEmailOnlyChannelSelection(channels: ChannelSelectionForm[]): boolean {
  return channels.length === 1 && channels[0].channel === "email";
}

export interface DateRangeValue {
  from: string;
  to: string;
}

export interface FilterRuleForm {
  id: string;
  type: string;
  value: string | string[] | DateRangeValue;
}

export interface CreateNotificationForm {
  type: NotificationCampaignType | "";
  channels: ChannelSelectionForm[];
  title: string;
  body: string;
  action_button_enabled: boolean;
  action_button_label: string;
  action_button_url: string;
  audience_type: NotificationAudienceType;
  filter_rules: FilterRuleForm[];
  csv_matched_user_ids: string[] | null;
  uploaded_file_name: string | null;
  schedule_type: NotificationScheduleType;
  schedule_date: string;
  schedule_time: string;
  is_recurring: boolean;
  recurrence_frequency: NotificationRecurrenceFrequency | null;
}

export const CHANNEL_META: Record<
  NotificationChannelType,
  { label: string; description: string }
> = {
  email: {
    label: "Email",
    description: "Rich HTML messages delivered to the inbox",
  },
  push: {
    label: "Push",
    description: "Instant alerts delivered to mobile & browser",
  },
  in_app: {
    label: "In-App",
    description: "Messages shown inside the product interface",
  },
};

export const RECIPIENT_TYPE_META: Record<NotificationRecipientType, string> = {
  mobile: "Mobile Users",
  business: "Business Users",
  both: "Both",
};

export const CAMPAIGN_TYPE_OPTIONS: {
  value: NotificationCampaignType;
  label: string;
}[] = [
  { value: "transactional", label: "Transactional" },
  { value: "promotional", label: "Promotional" },
  { value: "security_alert", label: "Security Alert" },
  { value: "announcement", label: "Announcement" },
  { value: "system", label: "System" },
  { value: "missing_documents", label: "Missing Documents" },
  { value: "exchange_rates", label: "Exchange Rates" },
];

export const EMPTY_CREATE_NOTIFICATION_FORM: CreateNotificationForm = {
  type: "",
  channels: [],
  title: "",
  body: "",
  action_button_enabled: false,
  action_button_label: "",
  action_button_url: "",
  audience_type: "all",
  filter_rules: [],
  csv_matched_user_ids: null,
  uploaded_file_name: null,
  schedule_type: "immediate",
  schedule_date: "",
  schedule_time: "",
  is_recurring: false,
  recurrence_frequency: null,
};
